import { useTranslate } from 'hooks/useTranslate';
import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

const SyncMatchingTable = ({
  matchingPaginated,
  firstMatchingNr,
  matchingEntries,
  matchingPagination,
  setMatchingPagination,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <p className="text-soft px-4 mb-3">
        {t('VerifyEmployeesMatchingIsCorrect')}
      </p>

      <div className="border-top border-bottom">
        <table className="table table-striped-inverse align-middle">
          <thead>
            <tr className="nk-tb-item tb-tnx-head">
              <th className="nk-tb-col align-middle">{t('Nr')}</th>
              <th className="nk-tb-col align-middle">{t('Beneficiary')}</th>
              <th className="nk-tb-col align-middle">{t('Cif')}</th>
              <th className="nk-tb-col align-middle">{t('Employee')}</th>
              <th className="nk-tb-col align-middle">
                {t('FactorialEmployeeId')}
              </th>
            </tr>
          </thead>

          {matchingEntries.length === 0 ? (
            <EmptyStateForTable
              mainMessage={t('SyncMatchingEmptyMainMessage')}
              infoMessage={t('SyncMatchingEmptyInfoMessage')}
              colspan={5}
            />
          ) : (
            <tbody>
              {matchingPaginated.map((pair, index) => (
                <tr key={pair.beneficiary._id} className="nk-tb-item">
                  <td className="nk-tb-col align-middle">
                    {firstMatchingNr + index}
                  </td>
                  <td className="nk-tb-col align-middle">
                    <div className="text-base">{pair.beneficiary.name}</div>
                    {pair.beneficiary.email && (
                      <small className="text-soft d-block">
                        {pair.beneficiary.email}
                      </small>
                    )}
                  </td>
                  <td className="nk-tb-col align-middle">
                    <span className="text-base">
                      {pair.beneficiary.cif || '—'}
                    </span>
                  </td>
                  <td className="nk-tb-col align-middle">
                    <div className="text-base">{pair.employee.name}</div>
                    {pair.employee.email && (
                      <small className="text-soft d-block">
                        {pair.employee.email}
                      </small>
                    )}
                  </td>
                  <td className="nk-tb-col align-middle">
                    <span className="text-base">
                      {pair.employee.externalId ?? '—'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>

      <div className="px-4">
        {matchingEntries.length > 0 && (
          <TablePagination
            totalRows={matchingEntries.length}
            defaultPage={matchingPagination.page}
            defaultRowsPerPage={matchingPagination.rowsPerPage}
            onChangePage={(page) =>
              setMatchingPagination((p) => ({ ...p, page }))
            }
            onChangeRowsPerPage={(rowsPerPage) =>
              setMatchingPagination({ page: 1, rowsPerPage })
            }
          />
        )}
      </div>
    </>
  );
};

export default SyncMatchingTable;
